import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Switch from '@material-ui/core/Switch';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import DownloadIcon from '@material-ui/icons/GetApp';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

const styles = theme => ({
    selected: {
        background: theme.palette.primary[100]
    },
    container: {
        overflow: 'auto',
        maxHeight: 300,
        paddingTop: '10px'
    },
});

class StoriesList extends React.Component {
    constructor(props) {
        super(props);
        const { classes } = props;
        this.state = { stories: [], selectedID: null };
    }
    componentDidMount() {
        this.setState({ stories: this.props.stories });
    }
    componentWillReceiveProps(nextProps) {
        this.setState({ stories: nextProps.stories });
    }
    handleListSelect(id, evt) {
        if (this.props.handleSelect)
            this.props.handleSelect(id);
        this.setState({ selectedID: id });
    }
    handleEdit(id, evt) {
        if(this.props.handleSelect)
            this.props.handleSelect(id);
        this.setState({selectedID: id});
    }
    handleDelete(id, evt) {
        if(this.props.handleDelete)
            this.props.handleDelete(id);
        this.setState({selectedID: id});
    }

    render() {
        let items = this.state.stories;
        const { classes } = this.props;
        let updatedStories = items.map(story=>{
            story.Display = true;
            return story;
        });
        let storyItems = null;
        if (updatedStories) {
            storyItems = updatedStories.map((item) =>
                (item.Display) &&
                <ListItem key={item.uuid} button onClick={this.handleListSelect.bind(this, item.slug)} className={item.slug == this.state.selectedID ? this.props.classes.selected : null}>
                    <ListItemText primary={item.title} secondary={`/${item.slug}`} />
                    <ListItemSecondaryAction>
                        <IconButton aria-label="Load" onClick={this.handleDelete.bind(this, item.uuid)}>                            
                            <DeleteIcon />
                        </IconButton>
                        <IconButton aria-label="Load" onClick={this.handleEdit.bind(this, item.uuid)}>                            
                            <EditIcon />
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
            );
        }
        if (storyItems.length!=0) {
            return (
                <List dense disablePadding className={classes.container}>
                    {storyItems}
                </List>
            );
        } else {
            return (
                <div style={{
                    color:'#e0e0e0',
                    lineHeight:'50px',
                    textAlign:'center',
                }}>
                    No stories
                </div>
            );
        }
    }
}

export default withStyles(styles)(StoriesList);